import { Button } from '@/app/common/components/button/Button.tsx'
import Tooltip from '@/common/components/Tooltip.tsx'
import { MinusIcon, PlusIcon } from '@/common/icons/arrows.tsx'
import { SideBarCloseIcon } from '@/common/icons/general.tsx'
import { cn } from '@/common/utilities.ts'
import { RootState } from '@/storage/store.ts'
import AceScholarshipsLogo from '@assets/ACEResized1.png'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  TransitionChild,
} from '@headlessui/react'
import { MouseEvent, ReactElement, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, Location, useLocation, useNavigate } from 'react-router-dom'
import { PrivilegeCode, useUserPrivileges } from '../hook/useUserPrivileges.tsx'
import { AppRoutePaths } from '../routing/route_paths.ts'
import { useLayout } from './LayoutProvider.tsx'

type MenuLink = {
  title: string
  icon?: ReactElement
  route: string
  children?: MenuLink[]
}

const MenuLinks: MenuLink[] = [
  {
    title: 'Dashboard',
    icon: <i className="ki-filled ki-category text-lg" />,
    route: AppRoutePaths.dashboard.index,
  },
  {
    title: 'Applicants',
    icon: <i className="ki-filled ki-users text-lg" />,
    route: AppRoutePaths.applicants.pre_selected.index,
    // children: [
    //   {
    //     title: 'Pre Selected',
    //     route: AppRoutePaths.applicants.pre_selected.index,
    //   },
    //   { title: 'Lottery', route: AppRoutePaths.applicants.lottery.index },
    //   { title: 'Selected', route: AppRoutePaths.applicants.selected.index },
    //   {
    //     title: 'Notifications',
    //     route: AppRoutePaths.applicants.notifications.index,
    //   },
    // ],
  },
  {
    title: 'Financial Task',
    icon: <i className="ki-filled ki-dollar text-lg" />,
    route: AppRoutePaths.financial_tasks.index,
  },
  {
    title: 'Payments',
    icon: <i className="ki-filled ki-wallet text-lg" />,
    route: AppRoutePaths.payments.index,
  },
  {
    title: 'Transactions',
    icon: <i className="ki-filled ki-dollar text-lg" />,
    route: AppRoutePaths.transactions.index,
  },
  {
    title: 'Providers',
    icon: <i className="ki-filled ki-handcart text-lg" />,
    route: AppRoutePaths.providers.index,
  },
  {
    title: 'Tasks',
    icon: <i className="ki-filled ki-bookmark text-lg" />,
    route: AppRoutePaths.tasks.index,
    children: [{ title: 'List', route: AppRoutePaths.tasks.index }],
  },
  /*   {
    title: 'Scholarships',
    icon: <i className="ki-filled ki-award text-lg" />,
    route: AppRoutePaths.scholarships.active_scholars.index,
    // children: [
    //   {
    //     title: 'Active Scholars',
    //     route: AppRoutePaths.scholarships.active_scholars.index,
    //   },
    //   {
    //     title: 'Scholar Notifications',
    //     route: AppRoutePaths.scholarships.notifications.index,
    //   },
    // ],
  }, */

  // {
  //   title: 'Vendors',
  //   icon: <i className="ki-filled ki-shop text-lg" />,
  //   route: AppRoutePaths.vendors.index,
  // },
  // {
  //   title: 'Providers',
  //   icon: <i className="ki-filled ki-delivery-3 text-lg" />,
  //   route: AppRoutePaths.providers.new.index,
  //   children: [
  //     { title: 'New', route: AppRoutePaths.providers.new.index },
  //     { title: 'Review', route: AppRoutePaths.providers.review.index },
  //     { title: 'Selected', route: AppRoutePaths.providers.selected.index },
  //   ],
  // },
  // {
  //   title: 'Reimbursement',
  //   icon: <i className="ki-filled ki-discount text-lg" />,
  //   route: AppRoutePaths.reimbursements.request.index,
  //   children: [
  //     { title: 'Request', route: AppRoutePaths.reimbursements.request.index },
  //     { title: 'Review', route: AppRoutePaths.reimbursements.review.index },
  //     { title: 'Declined', route: AppRoutePaths.reimbursements.declined.index },
  //     { title: 'Paid', route: AppRoutePaths.reimbursements.paid.index },
  //   ],
  // },
  // {
  //   title: 'Ledger',
  //   icon: <i className="ki-filled ki-book text-lg" />,
  //   route: AppRoutePaths.ledger.global.index,
  //   children: [
  //     { title: 'Global', route: AppRoutePaths.ledger.global.index },
  //     {
  //       title: 'Reimbursements',
  //       route: AppRoutePaths.ledger.reimbursements.index,
  //     },
  //     {
  //       title: 'Reconciliation',
  //       route: AppRoutePaths.ledger.reconciliation.index,
  //     },
  //   ],
  // },
  {
    title: 'Setup',
    icon: <i className="ki-filled ki-setting-2 text-lg" />,
    route: AppRoutePaths.setup.program.index,
    children: [
      { title: 'Program', route: AppRoutePaths.setup.program.index },
      {
        title: 'Purse Settings',
        route: AppRoutePaths.purse_settings.index,
      },
      { title: 'Users', route: AppRoutePaths.setup.users.index },

      { title: 'Roles', route: AppRoutePaths.setup.roles.index },
      {
        title: 'System Catalog',
        route: AppRoutePaths.setup.systemCatalog.index,
      },
      {
        title: 'Payment Approval Rules',
        route: AppRoutePaths.setup.category_and_product_rules.index,
      },
      {
        title: 'Provider Categories',
        route: AppRoutePaths.setup.provider_categories.index,
      },
      {
        title: 'Links',
        route: AppRoutePaths.setup.help_links.index,
      },
      {
        title: 'Provider Affiliations',
        route: AppRoutePaths.setup.provider_affiliations.index,
      },
      // { title: 'Global Items & Categories', route: AppRoutePaths.setup.global_items.index},
      {
        title: 'Bank Accounts',
        route: AppRoutePaths.setup.bank_accounts.index,
      },
      {
        title: 'Message Queue Logs',
        route: AppRoutePaths.setup.message_queue_logs.index,
      },
    ],
  },
] as const

type MenuLinkTitle = (typeof MenuLinks)[number]['title']
const menuAccessControls: Record<MenuLinkTitle, PrivilegeCode[]> = {
  Dashboard: ['dashboard_read'],
  Applicants: ['applicants_read'],
  Payments: ['applicants_read'],
  'Financial Task': ['applicants_read'],
  Providers: ['applicants_read'],
  Transactions: ['applicants_read'],
  Appeals: ['appeals_read'],
  Tasks: ['task_list_view_read'],
  Scholarships: ['scholarship_management_read'],
  Setup: ['roles_read', 'programs_read', 'users_read'],
} as const

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

type DesktopSidebarProps = {
  showNotification: (show: boolean) => void
}
export const DesktopSidebar = ({ showNotification }: DesktopSidebarProps) => {
  const { selectedProgramYear } = useSelector((s: RootState) => s.programs)
  const location = useLocation()
  const navigate = useNavigate()
  const { activeSidebarOpen, setDesktopNavOpen } = useLayout()

  const privileges = useUserPrivileges()

  const toggleSidebar = () => {
    if (selectedProgramYear !== null) {
      setDesktopNavOpen(!activeSidebarOpen)
    }
  }
  useEffect(() => {
    if (selectedProgramYear !== null && !activeSidebarOpen) {
      setDesktopNavOpen(true)
    }
  }, [selectedProgramYear])

  const handleNavigation = (
    event: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>,
    route: string
  ) => {
    if (selectedProgramYear === null) {
      event.preventDefault()
      showNotification(true)
    } else {
      navigate(route)
    }
  }

  const userAuthorizedMenuLinks = MenuLinks.map((menuLink) => {
    if (menuLink.title === 'Tasks') {
      const filteredChildren = menuLink.children?.filter((child) => {
        if (child.title === 'List') {
          return privileges.user['task_list_view_read']
        }

        return false
      })

      if (privileges.user['task_list_view_read']) {
        return {
          ...menuLink,
          children: filteredChildren,
        }
      }
      return null
    }

    if (menuLink.title === 'Setup') {
      const hasAnySetupAccess =
        privileges.user.programs_read ||
        privileges.user.users_read ||
        privileges.user.roles_read ||
        privileges.user.provider_management_read ||
        privileges.user.setup_bank_accounts_program_purses_read ||
        privileges.user.message_queue_logs_read

      if (!hasAnySetupAccess) {
        return null
      }

      return menuLink
    }

    if (
      menuAccessControls[menuLink.title]?.every(
        (privilegeCode) => privileges.user[privilegeCode]
      )
    ) {
      return menuLink
    }

    return null
  }).filter((menuLink): menuLink is MenuLink => menuLink !== null)

  const getLogoSrc = () => {
    return AceScholarshipsLogo
  }

  return (
    <div
      className={cn(
        'hidden bg-white w-72 lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col transition-width duration-300 ease-in-out',
        !activeSidebarOpen && 'w-[76px]'
      )}
    >
      <div className="grow flex flex-col gap-y-8 overflow-y-auto overflow-x-hidden border-r border-gray-200 bg-white py-4">
        <div className="px-2 flex h-16 shrink-0 items-center justify-center">
          {activeSidebarOpen ? (
            <img
              alt="Your Company"
              src={getLogoSrc()}
              className="h-auto"
              width="60%"
            />
          ) : (
            <img
              alt="Your Company"
              src={getLogoSrc()}
              className="h-auto"
              width="80%"
            />
          )}
          <Button
            type="button"
            onClick={() => toggleSidebar()}
            className="rounded-lg absolute -right-3.5 top-4 w-[30px] h-[30px] p-0 ring-gray-100 shadow-none"
            variant="outline"
          >
            <span className="sr-only">Toggle sidebar</span>
            <SideBarCloseIcon
              className={cn(
                'text-gray-500 hover:text-gray-700 transition-all duration-300',
                { 'rotate-180': !activeSidebarOpen }
              )}
            />
          </Button>
        </div>
        <nav className="px-4">
          <ul role="list" className="space-y-1">
            {userAuthorizedMenuLinks.map((menuLink) => (
              <li key={menuLink.title} className={cn('flex flex-col')}>
                {menuLink?.children == undefined || !activeSidebarOpen ? (
                  <>
                    {!activeSidebarOpen ? (
                      <Tooltip
                        message={menuLink.title}
                        className="[--anchor-gap:1.2rem] transition duration-200 ease-out data-[closed]:scale-75 data-[closed]:opacity-0 data-[closed]:-translate-x-4"
                      >
                        <Link
                          to={menuLink.route}
                          onClick={(event) =>
                            handleNavigation(event, menuLink.route)
                          }
                          className={cn(
                            'h-[45px] flex items-center rounded-lg py-2 px-2 w-full gap-x-3 text-sm font-semibold leading-6 text-gray-700',
                            menuLinkActive(location, menuLink) &&
                              'bg-primary-50 text-primary-600',
                            !menuLinkActive(location, menuLink) &&
                              'hover:bg-gray-50',
                            !activeSidebarOpen && 'max-w-max px-3'
                          )}
                        >
                          <span
                            className={cn(
                              'text-gray-400',
                              location.pathname.split('/')[1] ===
                                menuLink.route.split('/')[1] &&
                                'text-primary-600'
                            )}
                          >
                            {menuLink.icon}
                          </span>
                        </Link>
                      </Tooltip>
                    ) : (
                      <Link
                        to={menuLink.route}
                        onClick={(event) =>
                          handleNavigation(event, menuLink.route)
                        }
                        className={cn(
                          'h-[45px] flex items-center rounded-lg py-2 px-2 w-full gap-x-3 text-sm font-semibold leading-6 text-gray-700',
                          menuLinkActive(location, menuLink) &&
                            'bg-primary-50 text-primary-600',
                          !menuLinkActive(location, menuLink) &&
                            'hover:bg-gray-50',
                          !activeSidebarOpen && 'max-w-max px-3'
                        )}
                      >
                        <span
                          className={cn(
                            'text-gray-400',
                            location.pathname.split('/')[1] ===
                              menuLink.route.split('/')[1] && 'text-primary-600'
                          )}
                        >
                          {menuLink.icon}
                        </span>

                        {activeSidebarOpen && menuLink.title}
                      </Link>
                    )}
                  </>
                ) : (
                  <Disclosure>
                    {({ open }) => (
                      <div>
                        <DisclosureButton
                          className={cn(
                            'z-50 h-[45px] px-2 flex w-full items-center rounded-md',
                            menuLinkActive(location, menuLink) &&
                              'bg-primary-50 text-primary-600',
                            !menuLinkActive(location, menuLink) &&
                              'hover:bg-gray-50'
                          )}
                        >
                          <>
                            <span
                              className={cn('shrink-0 pr-3', {
                                'text-gray-400': !menuLinkActive(
                                  location,
                                  menuLink
                                ),
                              })}
                            >
                              {menuLink.icon}
                            </span>
                            <span
                              className={cn(
                                'text-sm font-semibold leading-6',
                                !menuLinkActive(location, menuLink) &&
                                  'text-gray-700'
                              )}
                            >
                              {menuLink.title}
                            </span>
                            <span className="text-sm text-gray-400 grow text-end">
                              {open ? <MinusIcon /> : <PlusIcon />}
                            </span>
                          </>
                        </DisclosureButton>
                        <DisclosurePanel
                          transition
                          as="ul"
                          className="z-0 transition duration-200 ease-linear data-[closed]:-translate-y-8 data-[closed]:opacity-0"
                        >
                          {menuLink.children?.map((subItem, index) => {
                            const hasPrivilege =
                              (subItem.title === 'Users' &&
                                privileges?.user?.users_read) ||
                              (subItem.title === 'Roles' &&
                                privileges?.user?.roles_read) ||
                              (subItem.title === 'Program' &&
                                privileges?.user?.programs_read) ||
                              (subItem.title === 'Purse Settings' &&
                                privileges?.user?.programs_read) ||
                              subItem.title === 'Global Items & Categories' ||
                              (subItem.title === 'List' &&
                                privileges?.user?.task_list_view_read) ||
                              (subItem.title === 'System Catalog' &&
                                privileges.user.provider_management_edit) ||
                              (subItem.title === 'System Catalog' &&
                                privileges.user.provider_management_read) ||
                              (subItem.title === 'System Catalog' &&
                                privileges.user.provider_management_create) ||
                              subItem.title === 'Provider Categories' ||
                              subItem.title === 'Payment Approval Rules' ||
                              subItem.title === 'Links' ||
                              (subItem.title === 'Bank Accounts' &&
                                privileges.user
                                  .setup_bank_accounts_program_purses_read) ||
                              subItem.title === 'Academic Terms' ||
                              (subItem.title === 'Provider Affiliations' &&
                                privileges.user.provider_management_read) ||
                              (subItem.title === 'Message Queue Logs' &&
                                privileges.user.message_queue_logs_read)

                            return hasPrivilege ? (
                              <li key={index} className="w-full">
                                <Link
                                  to={subItem.route}
                                  onClick={(event) =>
                                    handleNavigation(event, subItem.route)
                                  }
                                  className={cn(
                                    'flex items-center rounded-md p-2 text-sm leading-6 text-gray-700 hover:bg-gray-50'
                                  )}
                                >
                                  {subItem.icon && (
                                    <span className="mr-2">{subItem.icon}</span>
                                  )}
                                  <div
                                    className={cn('w-1.5 h-1.5 rounded mr-3', {
                                      'bg-primary-600': subLinkActive(
                                        location,
                                        subItem
                                      ),
                                    })}
                                  ></div>
                                  {subItem.title}
                                </Link>
                              </li>
                            ) : null
                          })}
                        </DisclosurePanel>
                      </div>
                    )}
                  </Disclosure>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="text-center text-gray-500 text-xs mt-auto">
          <div>v{import.meta.env.VITE_APP_VERSION}</div>
        </div>
      </div>
    </div>
  )
}

export const MobileSidebar = () => {
  const location = useLocation()
  const { setMobileNavOpen, mobileNavOpen } = useLayout()
  const privileges = useUserPrivileges()
  const userAuthorizedMenuLinks = MenuLinks.filter((menuLink) => {
    if (menuLink.title === 'Setup') {
      return (
        privileges.user.programs_read ||
        privileges.user.users_read ||
        privileges.user.roles_read ||
        privileges.user.provider_management_read ||
        privileges.user.setup_bank_accounts_program_purses_read ||
        privileges.user.message_queue_logs_read
      )
    }

    if (menuLink.title === 'Tasks') {
      return privileges.user.task_list_view_read
    }

    return menuAccessControls[menuLink.title].every(
      (privilegeCode) => privileges.user[privilegeCode]
    )
  })

  return (
    <Dialog
      open={mobileNavOpen}
      onClose={setMobileNavOpen}
      className="bg-white relative z-50 lg:hidden"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
      />

      <div className="fixed inset-0 flex">
        <DialogPanel
          transition
          className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
        >
          <TransitionChild>
            <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
              <button
                type="button"
                onClick={() => setMobileNavOpen(false)}
                className="-m-2.5 p-2.5"
              >
                <span className="sr-only">Close sidebar</span>
                <i className="ki-filled ki-cross"></i>
              </button>
            </div>
          </TransitionChild>
          <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 py-4">
            <div className="flex h-16 shrink-0 items-center">
              <img
                alt="Your Company"
                src={AceScholarshipsLogo}
                className="h-auto"
                width="60%"
              />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" className="space-y-4">
                    {userAuthorizedMenuLinks.map((menuLink) => (
                      <li key={menuLink.title} className="flex items-center">
                        {menuLink.children == undefined ? (
                          <>
                            <span
                              className={classNames(
                                location.pathname == menuLink.route
                                  ? 'text-primary-600'
                                  : 'text-gray-400 group-hover:text-primary-600',
                                'shrink-0 pr-2'
                              )}
                            >
                              {menuLink.icon}
                            </span>
                            <Link
                              to={menuLink.route}
                              className={classNames(
                                location.pathname == menuLink.route
                                  ? 'bg-gray-50 text-primary-600'
                                  : 'text-gray-700 hover:bg-gray-50 hover:text-primary-600',
                                'group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6'
                              )}
                            >
                              {menuLink.title}
                            </Link>
                          </>
                        ) : (
                          <Disclosure>
                            {({ open }) => (
                              <div className="w-full">
                                <DisclosureButton className="flex w-full items-center">
                                  <span
                                    className={cn('shrink-0 pr-2', {
                                      'text-gray-400 group-hover:text-primary-600':
                                        !menuLinkActive(location, menuLink),
                                      'text-primary-600': menuLinkActive(
                                        location,
                                        menuLink
                                      ),
                                    })}
                                  >
                                    {menuLink.icon}
                                  </span>
                                  <span
                                    className={cn(
                                      'rounded-md p-2 text-sm font-semibold leading-6',
                                      {
                                        'bg-gray-50 text-primary-600':
                                          menuLinkActive(location, menuLink),
                                        'text-gray-700 hover:bg-gray-50 hover:text-primary-600':
                                          !menuLinkActive(location, menuLink),
                                      }
                                    )}
                                  >
                                    {menuLink.title}
                                  </span>
                                  <span className="text-sm text-gray-400 ml-auto">
                                    {open ? <MinusIcon /> : <PlusIcon />}
                                  </span>
                                </DisclosureButton>
                                <DisclosurePanel
                                  as="ul"
                                  className="mt-1 px-2"
                                  data-headlessui-state="open"
                                  data-open
                                >
                                  {menuLink.children?.map((subItem, index) => {
                                    const hasPrivilege =
                                      (subItem.title === 'Users' &&
                                        privileges?.user?.users_read) ||
                                      (subItem.title === 'Roles' &&
                                        privileges?.user?.roles_read) ||
                                      (subItem.title === 'Program' &&
                                        privileges?.user?.programs_read) ||
                                      (subItem.title === 'Bank Accounts' &&
                                        privileges?.user
                                          ?.setup_bank_accounts_program_purses_read) ||
                                      (subItem.title === 'List' &&
                                        privileges?.user
                                          ?.task_list_view_read) ||
                                      (subItem.title ===
                                        'Provider Affiliations' &&
                                        privileges?.user
                                          ?.provider_management_read) ||
                                      (subItem.title === 'Message Queue Logs' &&
                                        privileges.user.message_queue_logs_read)

                                    return hasPrivilege ? (
                                      <li
                                        key={index}
                                        className="flex items-center"
                                      >
                                        <span className="w-1.5 h-1.5 rounded bg-primary-600 mr-2"></span>
                                        <Link
                                          to={subItem.route}
                                          className="block rounded-md py-2 pl-9 pr-2 text-sm leading-6 text-gray-700 hover:bg-gray-50"
                                        >
                                          {subItem.title}
                                        </Link>
                                      </li>
                                    ) : null
                                  })}
                                </DisclosurePanel>
                              </div>
                            )}
                          </Disclosure>
                        )}
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}

const menuLinkActive = (location: Location, menuLink: MenuLink) => {
  return location.pathname.split('/')[1] == menuLink.route.split('/')[1]
}

const subLinkActive = (
  location: Location,
  menuLink: Omit<MenuLink, 'icon'>
) => {
  return location.pathname == menuLink.route
}
